var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newProductRecordItem",on:{"click":_vm.godetail}},[_c('div',{staticClass:"time flex-js-ac"},[_c('div',{staticClass:"countdown flex-ac",class:{
        red: _vm.productItem.status == 1,
        yellow:
          _vm.productItem.status == 2 ||
          (_vm.productItem.status == 3 && _vm.productItem.giftstatus != 0) ||
          _vm.productItem.status == 4,
        orange: _vm.productItem.status == 3 && _vm.productItem.giftstatus == 0
      }},[_c('p',{staticClass:"f12 flex-ac"},[_c('van-icon',{attrs:{"name":"clock-o","size":"0.13rem","color":"#ffffff"}}),_vm._v("\n        "+_vm._s(_vm.productItem.status == 1
            ? '进行中'
            : _vm.productItem.status == 2 ||
              (_vm.productItem.status == 3 && _vm.productItem.giftstatus != 0) ||
              _vm.productItem.status == 4
            ? '已结束'
            : '已开奖')+"\n      ")],1),_vm._v(" "),_c('div',{staticClass:"f12 flex-ac"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.productItem.status == 1
              ? '距结束还剩'
              : _vm.productItem.status == 3 && _vm.productItem.giftstatus == 0
              ? '非常遗憾，未能申请成功'
              : _vm.productItem.time)+"\n        ")]),_vm._v(" "),(_vm.productItem.status == 1)?_c('van-count-down',{attrs:{"time":_vm.productItem.countdown},on:{"finish":_vm.finishFn}}):_vm._e(),_vm._v(" "),(
            _vm.productItem.status == 2 ||
            (_vm.productItem.status == 3 && _vm.productItem.giftstatus != 0) ||
            _vm.productItem.status == 4
          )?_c('span',[_vm._v("\n          截止\n        ")]):_vm._e()],1)]),_vm._v(" "),_c('span',{staticClass:"f12",class:{
        red: _vm.productItem.status == 1 || (_vm.productItem.status == 3 && _vm.productItem.giftstatus != 0),
        yellow: _vm.productItem.status == 2,
        orange: _vm.productItem.status == 3 && _vm.productItem.giftstatus == 0,
        gray: _vm.productItem.status == 4
      }},[_vm._v("\n      "+_vm._s(_vm.productItem.status == 1
          ? '已申请'
          : _vm.productItem.status == 2
          ? '待开奖'
          : _vm.productItem.status == 3 && _vm.productItem.giftstatus == 0
          ? '未中奖'
          : _vm.productItem.status == 4
          ? '已过期'
          : '已中奖')+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"product flex-ac"},[_c('img',{staticClass:"flex-s",attrs:{"src":_vm.productItem.image_path}}),_vm._v(" "),_c('div',{staticClass:"name flex-1"},[_c('p',{staticClass:"f14 over-ell-2"},[_vm._v(_vm._s(_vm.productItem.itemname))]),_vm._v(" "),(!(_vm.productItem.status == 3 && _vm.productItem.giftstatus == 3))?_c('span',{staticClass:"f12"},[_vm._v("\n        仅限"+_vm._s(_vm.productItem.limitnum)+"份   价值:¥"+_vm._s(_vm.productItem.costprice)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.productItem.status == 3 && _vm.productItem.giftstatus == 3)?_c('button',{staticClass:"f12 yellow-border",staticStyle:{"right":"0.82rem"},on:{"click":function($event){$event.stopPropagation();return _vm.btnFn1.apply(null, arguments)}}},[_vm._v("\n        查看反馈\n      ")]):_vm._e(),_vm._v(" "),(_vm.productItem.status == 3 && _vm.productItem.giftstatus != 0)?_c('button',{staticClass:"f12",class:{
          red: _vm.productItem.giftstatus == 1,
          yellow: _vm.productItem.giftstatus == 2 || _vm.productItem.giftstatus == 3
        },on:{"click":function($event){$event.stopPropagation();return _vm.btnFn.apply(null, arguments)}}},[_vm._v("\n        "+_vm._s(_vm.productItem.giftstatus == 1
            ? '领取'
            : _vm.productItem.giftstatus == 2 || _vm.productItem.giftstatus == 3
            ? '试用反馈'
            : '')+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d92d74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/newProductRecordItem.vue
// module id = null
// module chunks = 